<template>
  <div>
    <div>
      <div class="input-group mb-3">
        <div class="input-group-prepend">
          <span class="input-group-text">Search</span>
        </div>
        <input type="text" class="form-control" v-model="search" @input="filterData">
      </div>
    </div>

    <div>
      <div class="input-group mb-3">
        <div class="input-group-prepend">
          <span class="input-group-text">Sort by</span>
        </div>
        <select v-model="sortBy" @change="sort">
          <option value="bot">Bot Referrals</option>
          <option v-for="(title,index) in headers" :key="index" :value="index">{{ chat_names[title] }}</option>
        </select>
        <div class="input-group-append">
          <select v-model="order" @change="sort">
            <option value="asc">ASC</option>
            <option value="desc">DESC</option>
          </select>
        </div>
    
      </div>

      <div class="input-group mb-3" v-if="show_reset == true">
        <button  @click="$emit('resetReferralCount')" class="btn btn-outline-danger">Reset Referral Count</button>
      </div>


    </div>

    <div class="btn-group btn-group-justified w-100">
      <button @click="prev" class="btn btn-outline-info"><i class="fa fa-angle-double-left"></i></button>
      <button @click="downloadCSVData" class="btn btn-outline-primary btn-block">Download</button>
      <button @click="next" class="btn btn-outline-info"><i class="fa fa-angle-double-right"></i></button>
    </div>

    <div class="row">
      <div class="col col-xs-12">
        <p class="m-2">Showing {{start+1}} to {{end}} of {{filteredData.length}} entries</p>
      </div>
      <div class="col col-xs-12">
        <p class="m-2">Show <input type="number" v-model="entries" @input="changeEntries" /> entries </p>
      </div>
    </div>
    
    <table class="table table-striped mb-5 table-bordered">
      <thead>
        <tr>
          <th>Sl.No</th>
          <th>ID</th>
          <th>USERNAME</th>
          <th>NAME</th>
          <th>BOT REFERRALS</th>
          <th v-for="(title,index) in headers" :key="index">{{ chat_names[title] }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(row,index) in filteredData.slice(start, end)" :key="index">
          <td>{{start+index+1}}</td>
          <td>{{ row.id }}</td>
          <td>{{ row.username }}</td>
          <td>{{ row.first_name }} {{ row.last_name }}</td>
          <td>{{ row.referrals }}</td>
          <td v-for="(title,ind) in headers" :key="ind">{{ row.chat_referrals[title] }}</td>
        </tr>
      </tbody>
    </table>
    
  </div>
</template>

<style>
table {
    display: block;
    overflow-x: auto;
    white-space: nowrap;
}
</style>

<script type="text/javascript">
import TelegramService from "@/services/TelegramService";


export default {
  name: 'ReferralTable',
  props:{
    token: String,
    data: Array,
    show_reset: Boolean
  },
  data() {
    return {
      user: this.$store.state.user,
      isLoading: false,
      loaderColor: 'black',
      headers: [],
      search_headers: ["id", "username", "first_name","last_name"],
      chat_names: {},
      start: 0,
      end: 10,
      search: '',
      filteredData: this.data,
      entries: 10,
      sortBy: 0,
      order: 'asc'
    }
  },
  methods: {
    downloadCSVData(){
      let csv = 'Sl.No, ID, Username, Name, Bot Referrals, ' + this.headers.map((header) => this.chat_names[header]).join(', ') + '\n';
      let index = 0;
      this.filteredData.forEach((row) => {
        index = index + 1;
        let name = row.first_name +' '+ row.last_name
        csv +=  index+ ', ' + row.id + ', ' + row.username + ',' + name + ',' + row.referrals + ',' + this.headers.map((header) => row.chat_referrals[header]).join(', ') + '\n';
      });
  
      const anchor = document.createElement('a');
      anchor.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(csv);
      anchor.target = '_blank';
      anchor.download = 'Bot_creator_referrals.csv';
      anchor.click();
    },
    next(){
      if(this.end < this.filteredData.length){
        this.start = this.start + parseInt(this.entries);
        this.end = this.end + parseInt(this.entries);
        if(this.end>this.filteredData.length){
          this.end = this.filteredData.length;
        }
      }
    },
    prev(){
      if (this.start >= parseInt(this.entries)) {
        this.start = this.start - parseInt(this.entries);
        this.end = this.start + parseInt(this.entries);
      }else{
        this.start = 0
        this.end = parseInt(this.entries)
      }
      if(this.end>this.filteredData.length){
          this.end = this.filteredData.length;
      }
    },
    filterData(){
      if(this.search === ''){
        this.filteredData = this.data;
      }else{
        this.filteredData = this.data.filter((row) => {
          return this.search_headers.some((key) => {
            if(key in row && row[key] != null){
              return row[key].toString().toLowerCase().includes(this.search.toLowerCase());
            }else{
              return false;
            }
          });
        });
      }
      this.start = 0;
      let end = parseInt(this.entries);
      if(end>this.filteredData.length){
        this.end = this.filteredData.length;
      }else{
        this.end = end;
      }
    },
    changeEntries(){
      let end = this.start + parseInt(this.entries)
      if(end>this.filteredData.length){
        this.end = this.filteredData.length;
      }else{
        this.end = end;
      }
    },
    sort(){
      this.filteredData.sort((a,b) => {
        if(this.sortBy=='bot'){
          if(this.order=='asc'){
            return a.referrals - b.referrals;
            }else{
              return b.referrals - a.referrals;
            }
        }

        if (!('chat_referrals' in b)){
            let r = this.order === 'asc' ? 1: -1;
            return r
        }

        if (!('chat_referrals' in a)){
            let r = this.order === 'asc' ? -1: 1;
            return r
        }

        if(b.chat_referrals[this.headers[this.sortBy]] == undefined || b.chat_referrals[this.headers[this.sortBy]] == null){
            let r = this.order === 'asc' ? 1: -1;
            return r
        }
        
        if(a.chat_referrals[this.headers[this.sortBy]] == undefined || a.chat_referrals[this.headers[this.sortBy]] == null){
            let r = this.order === 'asc' ? -1: 1;
            return r
        }
        
        if(this.order === 'asc'){
          return a.chat_referrals[this.headers[this.sortBy]] > b.chat_referrals[this.headers[this.sortBy]] ? 1 : -1;
        }else{
          return a.chat_referrals[this.headers[this.sortBy]] < b.chat_referrals[this.headers[this.sortBy]] ? 1 : -1;
        }
      });
    },
    getTableheaders() {
      this.headers = [];
      this.data.forEach(
        function(subscriber) {
          if (!('chat_referrals' in subscriber)){
            subscriber.chat_referrals = {}
          }
          var keys = Object.keys(subscriber.chat_referrals);
          keys.forEach(function(key) {
              if (this.headers.indexOf(key) === -1) {
                this.headers.push(key);
              }
            }.bind(this)
          );
        }.bind(this)
      );
      this.headers.sort();
      //this.headers = ['id'].concat(this.headers);
    },
    getChatNames(){
      this.headers.forEach(
        function(chat_id) {
          TelegramService.getChat(this.token, chat_id)
          .then(function(r){
            this.$set(this.chat_names, chat_id, r.title)
            //this.chat_names[chat_id] = r.title;
          }.bind(this))
          .catch(function(response) {
            this.$dailog.alert(response.description);
          }.bind(this)
          );
        }.bind(this)
      );
    },
    
  },
  watch: {
    data(){
      this.filteredData = this.data;
    }
  },
  mounted() {
    this.getTableheaders();
    this.getChatNames();
  },
}

</script>
